{
  "name": "@kubb/ui",
  "version": "4.0.0",
  "description": "User interface components and web dashboard for Kubb, providing a visual interface for managing and monitoring code generation.",
  "keywords": [
    "ui",
    "dashboard",
    "web-interface",
    "react",
    "tailwindcss",
    "hono",
    "typescript",
    "kubb"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/kubb-labs/kubb.git",
    "directory": "packages/ui"
  },
  "license": "MIT",
  "author": "stijnvanhulle",
  "sideEffects": false,
  "type": "module",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./package.json": "./package.json"
  },
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.cts",
  "typesVersions": {
    "*": {}
  },
  "files": [
    "src",
    "static",
    "dist",
    "!/**/**.test.**",
    "!/**/__tests__/**"
  ],
  "scripts": {
    "build": "tsdown && vite build",
    "clean": "npx rimraf ./dist",
    "lint": "bun biome lint .",
    "lint:fix": "bun biome lint --fix --unsafe .",
    "preview": "vite preview",
    "release": "pnpm publish --no-git-check",
    "release:canary": "bash ../../.github/canary.sh && node ../../scripts/build.js canary && pnpm publish --no-git-check",
    "start": "vite & tsdown --watch",
    "test": "vitest --passWithNoTests",
    "typecheck": "tsc -p ./tsconfig.json --noEmit --emitDeclarationOnly false"
  },
  "dependencies": {
    "@hono/node-server": "^1.19.3",
    "@hono/zod-openapi": "0.19.2",
    "hono": "^4.9.8",
    "zod": "^3.25.76"
  },
  "devDependencies": {
    "@heroui/react": "^2.8.4",
    "@heroui/theme": "^2.4.22",
    "@heroui/use-theme": "^2.1.10",
    "@kubb/config-ts": "workspace:*",
    "@react-aria/visually-hidden": "^3.8.27",
    "@react-types/shared": "^3.32.0",
    "@tailwindcss/postcss": "^4.1.13",
    "@tanstack/react-query": "^5.89.0",
    "@types/node": "catalog:",
    "@types/react": "catalog:",
    "@types/react-dom": "catalog:",
    "@vitejs/plugin-react": "^5.0.3",
    "autoprefixer": "^10.4.21",
    "clsx": "^2.1.1",
    "framer-motion": "^12.23.15",
    "postcss": "^8.5.6",
    "react": "catalog:",
    "react-dom": "catalog:",
    "react-router-dom": "^7.9.1",
    "tailwind-variants": "^2.1.0",
    "tailwindcss": "^4.1.13",
    "tsdown": "catalog:",
    "typescript": "catalog:",
    "vite": "^7.1.6",
    "vite-tsconfig-paths": "^5.1.4"
  },
  "engines": {
    "node": ">=20"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  }
}
